import { Box, Button, Divider, Drawer, Stack, Typography, CircularProgress, Pagination } from "@mui/material";
import React, { useState, useEffect } from "react";
import { collection, getDocs, query, orderBy, limit, startAfter, getCountFromServer } from "firebase/firestore";
import { db } from "../../firebase";


function WalletList({ publisherId }) {
  const toggleDrawer = (newOpen) => () => {
    setOpenWalletDrawer(newOpen);
  };
  const [openWalletDrawer, setOpenWalletDrawer] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [lastVisibleByPage, setLastVisibleByPage] = useState({});
  const transactionsPerPage = 5;
  
  useEffect(() => {
    const fetchTransactions = async () => {
      if (openWalletDrawer && publisherId) {
        setLoading(true);
        try {
          const transactionsRef = collection(db, `/publishers/${publisherId}/transactions`);
          
          // Get total count for pagination (only once when drawer opens)
          if (page === 1 || Object.keys(lastVisibleByPage).length === 0) {
            const countSnapshot = await getCountFromServer(collection(db, `/publishers/${publisherId}/transactions`));
            setTotalPages(Math.ceil(countSnapshot.data().count / transactionsPerPage));
          }
          
          let q;
          if (page === 1) {
            q = query(transactionsRef, orderBy("timestamp", "desc"), limit(transactionsPerPage));
          } else if (lastVisibleByPage[page - 1]) {
            q = query(transactionsRef, orderBy("timestamp", "desc"), startAfter(lastVisibleByPage[page - 1]), limit(transactionsPerPage));
          } else {
            // If we don't have the previous page's last document, we can't fetch this page
          setLoading(false);
            return;
        }
          
          const querySnapshot = await getDocs(q);
          
          if (!querySnapshot.empty) {
            const transactionsData = querySnapshot.docs.map(doc => ({
              id: doc.id,
              ...doc.data()
            }));
            
            setLastVisibleByPage(prev => ({
              ...prev,
              [page]: querySnapshot.docs[querySnapshot.docs.length - 1]
            }));
            
            setTransactions(transactionsData);
          } else {
            setTransactions([]);
      }
        } catch (error) {
          console.error("Error fetching transactions:", error);
        } finally {
          setLoading(false);
        }
      }
    };
    
    fetchTransactions();
  }, [openWalletDrawer, publisherId, page]);
  
  const handlePageChange = (event, value) => {
    setPage(value);
  };
  
  const formatDate = (timestamp) => {
    if (!timestamp) return "";
    const date = timestamp.toDate();
    return `on ${date.getDate()}${getOrdinalSuffix(date.getDate())} ${date.toLocaleString('default', { month: 'long' })} ${date.getFullYear()}, ${date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })}`;
  };
  
  const getOrdinalSuffix = (day) => {
    if (day > 3 && day < 21) return "th";
    switch (day % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  };
  
  return (
    <>
      <Button
        onClick={() => {
          setOpenWalletDrawer(true);
        }}
      >
        View Transactions
      </Button>
      <Drawer
        open={openWalletDrawer}
        anchor={"right"}
        onClose={toggleDrawer(false)}
      >
        <Box sx={{ width: 500, p: 3 }}>
          <Box sx={{ width: "100%", marginBottom: "10px" }}>
            <Typography variant="h6">{"Transactions"}</Typography>
          </Box>
          <Divider />
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
              <CircularProgress />
            </Box>
          ) : (
            <>
              {transactions.map((transaction) => (
                <Box key={transaction.id} sx={{ paddingTop: "20px" }}>
                <Stack direction="row" justifyContent="space-between">
                  <Typography variant="subtitle1" component="div">
                      {transaction.message}
                  </Typography>
                 
                  <Typography
                    variant="h6"
                    component="div"
                      color={transaction.type === "credit" ? "green" : "red"}
                      textAlign="right"
                  >
                      {transaction.type === "credit" ? "+ " : "- "}₹{transaction.amount}
                    </Typography>
                  </Stack>
                {transaction.bookId && (<Typography variant="caption" color="grey">
                    {`Your book ID: ${transaction.bookId}, has sold! The sale price was Rs ${transaction.bookPrice}, and your ${transaction.commissionRate}% commission of Rs${transaction.amount} has been successfully added to your account.`}
                </Typography>)}
                {transaction.title && (<Typography variant="caption" color="grey">
                    {transaction.title}
                </Typography>)}
                <Box sx={{ textAlign: "end" }}>
                  <Typography variant="caption" color="grey">
                      {formatDate(transaction.timestamp)}
                  </Typography>
                </Box>
              </Box>
              ))}
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                <Pagination 
                  count={totalPages} 
                  page={page} 
                  onChange={handlePageChange} 
                  color="primary" 
                />
              </Box>
    </>
          )}
        </Box>
      </Drawer>
    </>
  );
}
export default WalletList;
